<script setup>
import { ref, watch } from 'vue';
import { refDebounced } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useUISettings } from 'dashboard/composables/useUISettings';
import NextButton from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const { uiSettings, updateUISettings } = useUISettings();

const htmlSignature = ref(uiSettings.value.html_signature || '');
// Each change reloads the preview frame; Chrome drops frame reloads that come
// too fast, so typing would leave the preview blank.
const previewHtml = refDebounced(htmlSignature, 400);

watch(
  () => uiSettings.value.html_signature,
  value => {
    htmlSignature.value = value || '';
  }
);

const saveSignature = () => {
  updateUISettings({ html_signature: htmlSignature.value.trim() });
  useAlert(t('PROFILE_SETTINGS.FORM.HTML_SIGNATURE_SECTION.API_SUCCESS'));
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="saveSignature">
    <textarea
      v-model="htmlSignature"
      rows="8"
      spellcheck="false"
      class="!mb-0 font-mono !text-xs"
      :placeholder="
        t('PROFILE_SETTINGS.FORM.HTML_SIGNATURE_SECTION.PLACEHOLDER')
      "
    />
    <div v-if="previewHtml.trim()" class="flex flex-col gap-1">
      <span class="text-sm text-n-slate-11">
        {{ t('PROFILE_SETTINGS.FORM.HTML_SIGNATURE_SECTION.PREVIEW') }}
      </span>
      <!-- Sandboxed: the HTML is shown as an email client would, without scripts. -->
      <iframe
        :srcdoc="previewHtml"
        sandbox=""
        :title="t('PROFILE_SETTINGS.FORM.HTML_SIGNATURE_SECTION.PREVIEW')"
        class="w-full h-56 bg-white border rounded-lg border-n-weak"
      />
    </div>
    <NextButton
      type="submit"
      :label="t('PROFILE_SETTINGS.FORM.HTML_SIGNATURE_SECTION.BTN_TEXT')"
      class="w-fit"
    />
  </form>
</template>
